import React, {useState, useRef } from 'react'
import { IoIosArrowRoundBack } from 'react-icons/io';
import  { Button, Checkbox, Label, Modal, TextInput, Datepicker, Select } from 'flowbite-react';
import { useGlobalModalContext } from './GlobalModal';
import { useContextState } from '../../context/Context';
import logo from '../../logo.png';
import 'react-phone-number-input/style.css';
import PhoneInput, { isValidPhoneNumber} from 'react-phone-number-input';
import { useAuth } from "../../store";
import Loader from '../shared/Loader'
import AlertComponent from '../shared/AlertComponent';

interface Props{
    back?:() => void;
    closeButton?:() => void;
    close: boolean;
    callBack?: () => void;
}

const regex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

const LoginModal: React.FC<Props> = ({callBack, close, back, closeButton}) => {
    const { hideModal, store } = useGlobalModalContext();
    const { modalProps } = store || {};
    const { title, confirmBtn } = modalProps || {};

    const { accountCTX } = useContextState();
    const { signedIn, setSignedIn } = accountCTX

    const [displayLoader, setDisplayLoader] = useState<boolean>(false);

    const [message, setMessage] = useState<string>('Sorry, an error occured ...');

    const [emailExists, setEmailExists] = useState<boolean>(false);
    const [isdisabled, setdisability] = useState<boolean>(true);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const [checkEmail, setCheckEmail] = useState<boolean>(true);
    const [login, setLogin] = useState<boolean>(false);
    const [signup, setSignup] = useState<boolean>(false);
    const [email, setEmail] = useState<string>('');
    const [username, setUsername] = useState<string>('');
    const [phoneNumber, setPhoneNumber] = useState<string | undefined>('');
    const [emailConfirmation, setEmailConfirmation] = useState<boolean>(false);
    const [signupEmailConfirmation, setSignupEmailConfirmation] = useState<string>('');
    const [passwordRecovery, setPasswordRecovery] = useState<boolean>(false);
    const [validUsername, setValidUsername] = useState<boolean>(false);
    const [samePassword, setSamePassword] = useState<boolean>(false);

    const { checkAccount, loginCall } = useAuth();

    const [underAge, setUnderAge] = useState<boolean>(true);

    const [openModal, setOpenModal] = useState<string | undefined>();
    const emailInputRef = useRef<HTMLInputElement>(null)
    const props = { openModal, setOpenModal, emailInputRef };

    const [currentLoginView, setCurrentLoginView] = useState<string>('default');


    const handleModalToggle = () => {
        hideModal();
    };

    const handleFormChange = async (e: React.FormEvent<HTMLFormElement>) => {
        e.persist();
        // console.log(login)

        if (checkEmail){
            setdisability(e.currentTarget.email.value.length < 4);
            setEmail(e.currentTarget.email.value)
        }

        else if (login){
            setdisability((e.currentTarget.password.value.length < 6))
        }
    };


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setDisplayLoader(true)

        if (checkEmail){
            setCheckEmail(false)
            const accountCheck = await checkAccount({username: email,});
            setDisplayLoader(false)
            setdisability(true)
            if (accountCheck){setEmailExists(accountCheck);setLogin(true)}
            else {
                if (regex.test(email)){setEmailExists(accountCheck);setSignup(true)}
                else {setCheckEmail(true);alert('Sorry, we did not find an account matching this pseudo. Kindly check the pseudo or provide an email to continue...')}
            }
        }

        else if (login){
            setLogin(false);
            const apiCall = await loginCall({username: email,password: e.currentTarget.password.value});
            setDisplayLoader(false)
            console.log(apiCall)
            if (apiCall) {
                setdisability(true);
                if (apiCall==='active'){setCurrentLoginView('success');setSignedIn(true);}
                else if (apiCall==='deleted'){
                    setLogin(true); 
                    setMessage('Sorry, you have deleted your account ... To recover your account, Kindly reset your password on the login page.'); 
                    setCurrentLoginView('error');}
                else if (apiCall === 'email_verification'){setEmailConfirmation(true);setSignupEmailConfirmation('signup')}
            }else{
                setLogin(true); 
                setMessage('Incorrect Credentials ...'); 
                setCurrentLoginView('error');
            }
            
        }

    };

    
    return (
        <div>
            <Modal
                // show={props.openModal === 'initial-focus'}
                show={true}
                size="md"
                popup
                onClose={()=> {return closeButton? closeButton():handleModalToggle()}}
                // onClose={handleModalToggle}
                // initialFocus={props.emailInputRef}
            >
                <Modal.Header>{back?<IoIosArrowRoundBack className="h-6 w-12 text-gray-600 group-hover:text-indigo-600" onClick={back} />:null}</Modal.Header>
                <Modal.Body>
                    {(currentLoginView ==='default')? 
                        <form onSubmit={handleSubmit} onChange={handleFormChange} >
                            <div className="space-y-6">
                                <div className="w-full flex justify-center ">
                                    <img className="flex justify-center shadow rounded-xl" src={logo} alt="Logo" width={63} />
                                </div>
                                <h3 className="flex justify-center text-lg font-medium text-gray-900 dark:text-white">FestiShare</h3>
                                <div>
                                    <div className="mb-2 block">
                                        <Label htmlFor="email" value="Kindly provide your email or pseudo to continue" />
                                    </div>
                                    <TextInput 
                                        id="email" 
                                        ref={props.emailInputRef} 
                                        placeholder="name@domain.com" 
                                        defaultValue={email}
                                        disabled={emailExists === true ? true : false} 
                                        // onChange={(e) => checkemail(e)}
                                        required 
                                    />
                                </div>

                                { displayLoader? 
                                    <Loader />: null
                                }
                                { login &&  
                                    <div>
                                        <div>
                                            <div className="mb-2 block">
                                                <Label htmlFor="password" value="Your password" />
                                            </div>
                                            <TextInput 
                                                type={isPasswordVisible ? "text" : "password"} 
                                                id="password" 
                                                // onChange={(e) => checkpassword(e)} 
                                                required 
                                            />
                                        </div>
                                        
                                        <div className="flex justify-between mt-2">
                                            <div className="flex items-center gap-2">
                                                <Checkbox id="seePassword" onClick={()=>{isPasswordVisible ? setIsPasswordVisible(false):setIsPasswordVisible(true)}}/>
                                                <Label htmlFor="seePassword">See Password</Label>
                                            </div>
                                        </div> 
                                    </div>
                                }
                                

                                <div className="w-full flex justify-center mt-6">
                                    <Button type='submit' disabled={isdisabled} >Continue</Button>
                                </div>
                            </div>
                        </form>:null
                    }

                    {(currentLoginView ==='success')? 
                        <AlertComponent 
                            callBack={() => {
                                if (close){return hideModal()}
                                else if (callBack){return callBack()}
                                else {return setCurrentLoginView('')}
                            }} 
                            type='success' 
                            subject='Success' 
                            message='Congratulations, you have successfully logged in ...' 
                        />: null
                    } 

                    {(currentLoginView ==='error')? 
                        <AlertComponent 
                            callBack={() => {setCurrentLoginView('default')}} 
                            type='error' 
                            subject='Failed' 
                            message={message}
                        />: null
                    } 
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default LoginModal